import { useState, type VoidFunctionComponent } from 'react';

import { useParams } from '../../../contexts/RouterContext';
import { useDebouncedInputValue } from '../../../hooks';
import { SearchInput } from '../../generic';
import { TreeViewLayout } from '../shared/TreeViewLayout';
import type { RevisionRouteParams } from '../projectDashboardTypes';

import VendoredDependenciesTreeView from './TreeView';

import { summarizePath } from './utils';

import styles from './VendoredDependencies.module.less';

/**
 * Root component for the Vendored Dependencies page.
 * Includes only the content of the page, the SidebarNavLayout is handled in the parent route.
 */
const VendoredDependenciesContainer: VoidFunctionComponent = () => {
  //  Note: this will change (and probably be moved) but for now this pulls the dummy data so we can see it.
  const params = useParams<RevisionRouteParams>();
  const userRevisionLocator = `${params.project_id}$${params.revision_id}`;

  // Track which path is currently selected
  const [selectedPath, setSelectedPath] = useState<string | null>(null);

  //  TODO: Later this will actually be used
  const { value, onChange } = useDebouncedInputValue();

  return (
    <>
      <header className={styles.header}>
        <h1 className={styles.title}>
          Vendored Dependencies
        </h1>
        <span className={styles.summary}>
          {/* Note: later this will include the count, once we hook that up */}
          Vendored dependencies found in <span className="bold">{summarizePath(selectedPath ?? '/')}</span>
        </span>
      </header>
      <div>
        <span className={styles.search}>
          <SearchInput
            label="vendored-dependencies-filter-search"
            placeholder="Search dependencies"
            size="small"
            value={value}
            onChange={onChange}
          />
        </span>
        {/* TODO: later if we add more filters or the compare button, it will go here */}
      </div>
      <TreeViewLayout>
        <VendoredDependenciesTreeView
          userRevisionLocator={userRevisionLocator}
          selectedPath={selectedPath}
          setSelectedPath={setSelectedPath}
        />
        {/* TODO: this will be extracted into a component later */}
        <TreeViewLayout.Table header="Components (0)">
          <div>
            Dependencies table
          </div>
        </TreeViewLayout.Table>
      </TreeViewLayout>
    </>
  );
};

export default VendoredDependenciesContainer;
